export const formattedDateTime = (date: Date) => {
  const stringDateTime =
    date.getFullYear() +
    "/" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "/" +
    date.getDate().toString().padStart(2, "0") +
    " " +
    date.getHours().toString().padStart(2, "0") +
    ":" +
    date.getMinutes().toString().padStart(2, "0") +
    ":" +
    date.getSeconds().toString().padStart(2, "0") +
    "." +
    date.getMilliseconds().toString().padStart(3, "0");
  return stringDateTime;
};

export const removeMilliseconds = (timestamp: string): string => {
  if (!/^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/.test(timestamp)) {
    return timestamp;
  }
  return timestamp.replace(/\.\d{3}$/, "");
};

export const SeparateDateWithSlash = (
  date: string | undefined | null,
): string => {
  if (!date) return "";
  if (!/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
    return date;
  }
  return date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$1/$2/$3");
};

export const extractDate = (timestamp: string) => {
  const regex = /^(\d{4}\/\d{2}\/\d{2}) \d{2}:\d{2}:\d{2}\.\d{3}/;
  const match = timestamp.match(regex);
  return match ? match[1] : "";
};

export const extractHourAndMinute = (timestamp: string) => {
  const regex = /^\d{4}\/\d{2}\/\d{2} (\d{2}:\d{2})\:\d{2}\.\d{3}/;
  const match = timestamp.match(regex);
  return match ? match[1] : "";
};
